import React from 'react';
import { getResourceColor, getInitials } from '../../../../utils/resourceUtils';
import { getStatus, formatLicenses } from '../employeeUtils';

/**
 * EmployeeCard Component - Renders an individual employee tile.
 */
export function EmployeeCard({ 
    emp, 
    absences, 
    employees, 
    onEdit, 
    onDelete, 
    onManageAbsence 
}) {
    const status = getStatus(emp.id, absences);
    const avatarColor = getResourceColor(emp);
    const initials = getInitials(emp.name);
    const replacement = employees.find(e => e.id === emp.vacation_replacement_id);

    return (
        <div className="employee-card clickable" onClick={onEdit}>
            <div className="employee-card-header">
                <div className="employee-avatar" style={{ background: avatarColor }}>
                    {initials}
                </div>
                <div className="employee-card-name-row">
                    <div className="employee-card-name">{emp.name}</div>
                </div>
                
                {/* NEW: Status Indicator Top Right */}
                <div className="employee-card-status-badge">
                    <span className="status-dot-mini" style={{ background: status.color }}></span>
                    <span className="card-status-label" style={{ color: '#1d1d1f', opacity: 1 }}>{status.label}</span>
                </div>
            </div>

            <div className="employee-info-rows">
                <div className="employee-info-row">
                    <span className="employee-info-icon">👔</span>
                    <span className="employee-info-value">{emp.category_name || '—'}</span>
                </div>
                <div className="employee-info-row">
                    <span className="employee-info-icon">✉️</span>
                    <span className="employee-info-value" title={emp.email}>{emp.email || '—'}</span>
                </div>
                <div className="employee-info-row">
                    <span className="employee-info-icon">📱</span>
                    <span className="employee-info-value">{emp.phone || '—'}</span>
                </div>
                <div className="employee-info-row">
                    <span className="employee-info-icon">🚗</span>
                    <span className="employee-info-value">{formatLicenses(emp) || '—'}</span>
                </div>
                <div className="employee-info-row">
                    <span className="employee-info-icon">🔄</span>
                    <span className="employee-info-value">{replacement ? replacement.name : 'Keine Vertretung'}</span>
                </div>
            </div>

            <div className="employee-card-actions">
                <button 
                    className="employee-card-action-btn" 
                    onClick={(e) => { e.stopPropagation(); onManageAbsence(); }}
                    title="Abwesenheiten verwalten"
                >
                    <span>📅</span> Abwesenheit
                </button>
                <button 
                    className="employee-card-action-btn" 
                    onClick={(e) => { e.stopPropagation(); onEdit(); }}
                    title="Mitarbeiter bearbeiten"
                >
                    <span>✏️</span> Bearbeiten
                </button>
                
                {/* NEW: Delete Button for manual employees */}
                {!emp.user_id && (
                    <button 
                        className="employee-card-action-btn danger" 
                        onClick={(e) => { e.stopPropagation(); onDelete(); }}
                        title="Mitarbeiter löschen"
                    >
                        <span>🗑️</span> Löschen
                    </button>
                )}
            </div>
        </div>
    );
}
